// extracted by mini-css-extract-plugin
module.exports = {"subheadline":"sub-headline-m__subheadline__2QL-l"};